import SignupPageDesigner from '@admin/components/signup_page_designer'
import Panel from '@admin/components/panel'
import React from 'react'

class SignupPage extends React.Component {

  static propTypes = {}

  render() {
    return <SignupPageDesigner { ...this._getSignupPageDesigner() } />
  }

  _getSignupPageDesigner() {
    return {
      endpoint: '/api/admin/truevail/agency/signup_page',
      signup_page_id: 11
    }
  }

}

const mapPropsToPanel = (props, context) => ({
  title: 't(Signup Page)',
  component: <SignupPage />
})

export default Panel(null, mapPropsToPanel)
